import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/aurora.css";
import { applyTheme } from "./utils/branding";

applyTheme(); // set <html data-theme> before first paint

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
